<template>
  <!-- breadcrumb e filtros (provedores e ordenação) -->
  <div :class="$vuetify.breakpoint.xs ? 'px-4' : 'pl-4'">
    <v-breadcrumbs
      v-show="breadcrumbs.length > 0"
      :items="breadcrumbs"
      link
      class="py-0 pl-1"
    >
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
      <template v-slot:item="{ item }">
        <v-breadcrumbs-item
          :to="item.href"
          :active-class="!item.disabled ? '' : undefined"
        >
          <span>
            {{ item.text }}
          </span>
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>

    <v-row style="flex-wrap: nowrap" class="justify-end">
      <!-- Select providers -->
      <v-col
        class="flex-grow-1 flex-shrink-0"
        :style="$vuetify.breakpoint.mobile ? '' : 'width: 300px'"
      >
        <v-select
          v-if="$route.matched[3].name !== 'casinoProviders'"
          v-model="providersFilter"
          :items="selectableProviders"
          :label="$t('newCasino.providers')"
          item-text="name"
          item-value="id"
          multiple
          dense
          outlined
          hide-details
          :no-data-text="$t('newCasino.noProvidersFound')"
          :menu-props="{ 'nudge-top': -42 }"
        >
          <!-- :class="selectedProviders.length >=3 ? 'col-4  pa-0 mr-16' : 'col-3 pa-0 mr-16' " -->
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0" small>
              <span
                class="text-truncate"
                :style="{
                  'max-width': providersFilter.length == 1 ? '22ch' : '13ch',
                }"
              >
                {{ item.name }}
              </span>
            </v-chip>
            <span v-if="index === 1" class="grey--text text-caption pl-1">
              (+{{ providersFilter.length - 1 }} {{ $t("newCasino.others") }})
            </span>
          </template>
          <template v-slot:item="{ item }">
            <div class="d-flex flex-row">
              <v-img
                :src="item.smallLogo"
                style="width: 24px;"
              >
                <template v-slot:placeholder>
                  <div class="d-flex align-center justify-center fill-height">
                    <v-progress-circular
                      color="grey-lighten-4"
                      indeterminate
                    ></v-progress-circular>
                  </div>
                </template>
              </v-img>
              <div class="ml-4 text-truncate" style="max-width: 22ch;">
                {{ item.name }}
              </div>
            </div>
          </template>
        </v-select>
      </v-col>
      <!-- A - Z / Z - A -->
      <v-col class="flex-grow-0 flex-shrink-1" style="max-width: 120px">
        <v-select
          v-model="selectedAlphabeticalOrder"
          :items="orderBy"
          :label="$t('newCasino.orderBy')"
          item-text="text"
          item-value="value"
          outlined
          dense
          hide-details
          :menu-props="{ 'nudge-top': -42 }"
        >
        </v-select>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: ["providers", "originalItems"],
  data: () => ({
    id: "",
    orderBy: [
      {
        text: "A - Z",
        value: "A - Z",
      },
      {
        text: "Z - A",
        value: "Z - A",
      },
    ],
  }),

  computed: {
    selectableProviders() {
      return this.providers.filter((provider) => {
        return this.originalItems.find(
          (game) => game.id_provider === provider.id
        );
      });
    },
    selectedAlphabeticalOrder: {
      get() {
        return this.$store.state.casinoFilters.alphabeticalOrder;
      },
      set(order) {
        this.$store.commit("setCasinoAlphabeticalOrderFilter", order);
      },
    },
    providersFilter: {
      get() {
        return this.$store.state.casinoFilters.providers;
      },
      set(providers) {
        this.$store.commit("setCasinoProvidersFilter", providers);
      },
    },
    breadcrumbs() {
      if (
        this.$route.name === "casinoCategory" ||
        this.$route.name === "casinoFavorites"
      ) {
        return [];
      }

      const items = [];

      if (this.$route.matched[2].name === "casinoLobby") {
        items.push({
          text:
            this.$route.params.casinoType == "casino"
              ? this.$t("casino")
              : this.$t("liveCasino"),
          href: `/casino/lobby/${this.$route.params.casinoType}`,
          disabled: this.$route.name === "casinoLobby",
        });
      }

      if (this.$route.matched[3].name === "casinoProviders") {
        items.push({
          text: this.$t("newCasino.providers"),
          href: `/casino/lobby/${this.$route.params.casinoType}/providers`,
          disabled:
            this.$route.path.includes(
              `/casino/lobby/${this.$route.params.casinoType}/providers`
            ) && this.$route.name === "casinoProviders",
        });
      }

      if (
        this.$route.params.providerId &&
        this.providers &&
        this.providers.length > 0
      ) {
        const providerName = this.providers.find(
          (provider) => provider.id == this.$route.params.providerId
        ).name;

        items.push({
          text: providerName,
          href: `/casino/lobby/${this.$route.params.casinoType}/providers/${this.$route.params.providerId}`,
          disabled: true,
        });
      }

      if (this.$route.params.category) {
        items.push({
          text: this.$route.params.category,
          href: encodeURI(
            `/casino/lobby/${this.$route.params.casinoType}/category/${this.$route.params.category}`
          ),
          disabled: true,
        });
      }

      return items;
    },
  },
};
</script>

<style></style>
